import React, { useState } from "react";
import { handlePauseAllVideo, removeStylesFromHtml } from "../../../utils";
import { ReactComponent as ArrowUpIcon } from "../../../Icons/arrowUp.svg";
import { ReactComponent as ArrowDownIcon } from "../../../Icons/arrowDown.svg";
import { ReactComponent as RFUIcon } from "../../../Icons/rfuIcon.svg";
import { ReactComponent as VerifyIcon } from "../../../Icons/verify.svg";
import { ReactComponent as CopyIcon } from "../../../Icons/copy.svg";
import { ReactComponent as ShareIcon } from "../../../Icons/share.svg";
import Voting from "../../Voting/Voting";
import Button2 from "../../Button2/Button2";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import ImgCarousal from "../../Carousal/carousal";
import Button from "../../Button/Button";
import { CURRENT_ROLE } from "../../../API/url";
import { message } from "antd";
import { ColorLens } from "@mui/icons-material";
import Rating from "../../Rating/Rating";
import TooltipComp from "../../ToolTip/TooltipComp";
import Styles from './styles.module.css'
const contentStyle = {
  border: "1px solid #E0E2E6",
  borderRadius: "16px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  width: '100%'
};
export default function Answer({ data, onClickStapleAnswer, stapple = false, question }) {
  // console.log(data.attachmentURL,'hi')

  console.log("declined data", question);
  // console.log("declined answer",answers)
  const domainState = useSelector((state) => state.domain.ratings);
  const editorState = useSelector(state => state.editor);
  const [messageApi, contextHolder] = message.useMessage();
  const [isStapled, setIsStapled] = useState(false);
  const randomNumber = Math.random() * 10;
  const dispatch = useDispatch();
  const { advanceFilterModalToggle, getSelectedQuestion, getSelectedAnswer } = bindActionCreators(Actions, dispatch)
  const successfulHelpful = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };

  const StapleAnswerRender = ({ ans }) => {
    // console.log('anser',ans.answers[0].answerText)
    // const ans1=ans.answers[0].answerText
    // console.log('typeof', typeof ans)
    const [stapleCheck, setStapledCheck] = useState('');
    const onClickStapleAnswer2 = (str) => {
      // console.log("str", str)
      setIsStapled(true);
      onClickStapleAnswer(str);
    }
    return (
      <>
        <span style={{ color: "var(--dark_color_shade)", cursor: "pointer", fontSize: "14px" }} onClick={() => onClickStapleAnswer2(ans)}>
          <i className="fa fa-files-o" style={{ paddingRight: "5px" }}></i>Staple the answer


        </span>
      </>
    )
  }

  const ratingIdValue = question.filter((item) => {
    // console.log("filter item", item)
  })
  const [stapleCheck, setStapledCheck] = useState('');
  const onClickCopy = (text) => {

    // let newString = stripHtml(data.answerText);
    // navigator.clipboard.writeText(`${question.question}\n\n${newString}`);

  }

  // const StapleAnswerRender = ({ ans }) => {
  //     const [stapleCheck, setStapledCheck] = useState('');
  //     console.log("stapple string",ans)
  //     const onClickStapleAnswer2 = (str) => {

  //       setIsStapled(true);
  //       onClickStapleAnswer(str);
  //     }
  //     return (
  //       <>
  //         <span style={{ color: "var(--dark_color_shade)", cursor: "pointer", fontSize: "14px" }} onClick={() => onClickStapleAnswer2(ans)}>
  //           <i className="fa fa-files-o" style={{ paddingRight: "5px" }}></i>Staple the answer
  //         </span>
  //       </>
  //     )
  //   }
  const onClickStapleAnswer2 = (str) => {
    // console.log("str", str)
    setIsStapled(true);
    // let newString = stripHtml(str);
    // navigator.clipboard.writeText(`${question.question}\n\n${newString}`);
    onClickStapleAnswer(str);
  }

  // const stripHtml=(htmlString)=>{
  //   return htmlString
  //   .replace(/<br\s*\/?>/gi, "\n")
  //   .replace(/<\/p>/gi, "\n\n")
  //   .replace(/<\/?[^>]+(>|$)/g, "");
  // }
  // const onClickStapleAnswer = (str) => {
  //   setIsStapled(true);

  //   setTx(str.answerCopy)
  //   if(currentRoute.pathname.includes('editor')){
  //     let newStr = editorState.answerText.concat(str.answerText);
  //     updateAnswerTextForEditor(newStr)
  //   }else{
  //     props.onchangeVal(str);
  //   }
  //   window.scrollTo({ top: 0, behavior: 'smooth' });
  // }
  const ratingState = useSelector((state) => state.domain);
  const userState = useSelector((state) => state.user);
  const [permission, setPermission] = useState(userState.roles.find(data => data.roleName === CURRENT_ROLE).permissions.find(item => item.id === 9));
  const searchState = useSelector((state) => state.search);
  const [isAccept, setAccept] = useState(null);
  const [isPlay, setPlay] = useState(false);
  const [isShow, setShow] = useState(false);
  const trimString = (str) => {
    if (str?.length > 350) {
      return str?.slice(0, 350) + "...";
    }
    return str;
  };
  const ansStyles = {
    marginTop: "10px",
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "24px",
    fontWeight: "300",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const showMoreStyles = {
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "500",
    background:
      "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
    "-moz-text-fill-color": "transparent",
    "-ms-text-fill-color": "transparent",
    "-o-text-fill-color": "transparent",
    cursor: "pointer",
    marginTop: "5px",
  };

  const onClickButton = (key) => {
    // console.log("");
  };

  // const onClickRFU = () => {
  //   advanceFilterModalToggle({ bool: true, value: "requestForUpdate" });
  //   getSelectedAnswer(data);
  //   getSelectedQuestion(question);
  // };
  const stripHtml = (htmlString) => {
    return htmlString
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n\n")
      .replace(/<\/?[^>]+(>|$)/g, "");
  }
  const success = () => {
    messageApi.info("hl");
  };
  // const onClickCopy=(text)=>{
  //   toast.success(successfulHelpful("Text copied!"), {
  //     position: toast.POSITION.TOP_RIGHT,
  //   });
  //     let newString = stripHtml(data.answerText);
  //     navigator.clipboard.writeText(`${question.question}\n\n${newString}`);

  // }
  const onClickPlayPause = () => {
    setPlay(!isPlay);
    // if(isPlay){
    //   document.getElementById(`${question.questionUuid}_${randomNumber}`).pause();
    // }else{
    //   document.getElementById(`${question.questionUuid}_${randomNumber}`).play();
    // }
  }

  return (
    <>
      {data.answers.map((answer, index) => (
        <div key={index} className="answer-section">
          {answer.attachments?.length > 0 &&
            answer.attachments.some(att => att.name.includes('.mp4') || att.name.includes('.mov')) && (
              <>
                <div className="mt-1" style={{ textAlign: 'right' }}>
                  <Button
                    type="primary"
                    text={isPlay ? 'Hide Video' : 'Show Video'}
                    onClickFunc={onClickPlayPause}
                  />
                </div>
                {isPlay && (
                  <div className="mb-4 mt-3" style={{ textAlign: 'center' }}>
                    {answer.attachments
                      .filter(att => att.name.includes('.mp4') || att.name.includes('.mov'))
                      .map((video, index) => (
                        <video
                          key={index}
                          id={`${answer.questionUuid}_${randomNumber}_${index}`}
                          controls
                          onBlur={handlePauseAllVideo}
                          style={contentStyle}
                        >
                          <source src={`${video.objectUrl}#t=${answer.startTime},${answer.endTime}`} type="video/mp4" />
                        </video>
                      ))}
                  </div>
                )}
              </>
            )}



          {answer.attachmentURL?.length > 0 && !stapple && (
            <div className="mb-4 mt-3">
              <ImgCarousal data={answer.attachmentURL} />
            </div>
          )}
          <div
            style={ansStyles}
            dangerouslySetInnerHTML={{
              __html: !isShow
                ? removeStylesFromHtml(trimString(answer.answerText || answer.contextData))
                : removeStylesFromHtml(answer.answerText || answer.contextData),
            }}
          ></div>

          <div style={{ marginTop: "10px" }}>
            {(answer.answerText?.length > 350 || answer.contextData?.length > 350) && (
              <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                {isShow ? "Show less" : "Show more"}&nbsp;
                {isShow ? <ArrowUpIcon /> : <ArrowDownIcon />}
              </div>
            )}
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: "6px", paddingTop: "5px" }}>
            {/* {console.log("answer")} */}
            {/* {console.log("rating", answer?.origAnswerUuid, answer?.answerUuid)} */}
            {/* {
    //  domainState !== null &&
    //  domainState[answer.origAnswerUuid === undefined ?answer?.origAnswerUuid:answer.answerUuid].rating !== undefined &&
     
    ratingState?.ratings &&
    ratingState.ratings[answer?.origAnswerUuid] !== null &&!stapple && !editorState?.ratingBool&&<Button2 onClickFunc={onClickButton}>
                        <Rating id={answer?.origAnswerUuid!==null?answer?.origAnswerUuid:answer?.answerUuid} />
        </Button2>
        } */}

            {
              ratingState?.ratings &&
              ratingState.ratings[answer?.origAnswerUuid ?? answer?.answerUuid] !== null &&
              !stapple &&
              editorState?.ratingBool===false && (
                <Button2 onClickFunc={onClickButton}>
                  <Rating id={answer?.origAnswerUuid ?? answer?.answerUuid} />
                </Button2>
              )
            }

            {
              stapple &&

              <Button2 onClickFunc={() => onClickStapleAnswer2(answer)}>
                <TooltipComp title={'Staple the answer'}>
                  <CopyIcon id={data.docId === null ? data.answers[0].answerUuid : data.docId} /></TooltipComp>
              </Button2>

            }

          </div>
          {/* {data.answers.length>1&& <p className={Styles.onSelectedtab} style={{ marginBottom: '10px', marginTop: '15px' }}></p>} */}
        </div>


      ))}

      {/* <p className={Styles.onSelectedtab} style={{ marginBottom: '10px', marginTop: '15px' }}></p> */}

    </>
  );
}
